import { mergeEnv } from '@nablax/shared/config';
import { boolean, number, object, string } from 'yup';
import { CONSTANTS } from './constants';

/**
 * ensure no trailing slash at the end of the url
 * @param value input value
 * @returns
 */
const urlNoTrailingSlash = (value: any) =>
  typeof value === 'string' && value.lastIndexOf('/') === value.length - 1
    ? value.substring(0, value.length - 1)
    : `${value}`;

const ENV_SCHEMA = object({
  VITE_SOFTWARE_NAME: string()
    .oneOf([CONSTANTS.softwareName])
    .default(CONSTANTS.softwareName),
  VITE_ALLOW_LOCAL_PROJECTS: boolean()
    .transform((value) => {
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      return Boolean(value);
    })
    .default(false)
    .optional(),
  VITE_FPS_COUNTER: boolean()
    .transform((value) => {
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      return Boolean(value);
    })
    .default(false)
    .optional(),
  VITE_GIZMO_HELPER: boolean()
    .transform((value) => {
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      return Boolean(value);
    })
    .default(true)
    .optional(),
  VITE_SYNC_INTERVAL_MS: number()
    .transform((value) => {
      const num = Number(value);
      return isNaN(num) ? 4000 : num;
    })
    .default(4000)
    .optional(),
});

export const env = mergeEnv(import.meta.env, ENV_SCHEMA);
